import React from "react";
import CookiesUsePolicy from "../Components/CookiesUsePolicy";

function Cookies() {
  return <CookiesUsePolicy />;
}

export default Cookies;
